module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "product-item",
    style: (_vm.cardStyle)
  }, [_c('h3', [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "product_item_img_box",
    style: ({
      background: 'url(' + _vm.background + ')'
    })
  }, [_c('app-img', {
    staticClass: "card_img",
    attrs: {
      "src": _vm.item.logo
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.note[0]))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.note[1]))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d89131b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/Card.vue
// module id = 182
// module chunks = 1